<div class="custom-month-year-picker" [class.disabled]="disabled" clickOutside (clickOutside)="closeCalendar()">
  <!-- Input Field -->
  <div class="date-input-container" (click)="toggleCalendar()">
    <input 
      type="text" 
      class="date-input" 
      [placeholder]="placeholder"
      [value]="getDisplayValue()"
      [disabled]="disabled"
      readonly
    />
    <div class="calendar-icon">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="clear-button" *ngIf="selectedMonthYear" (click)="clearSelection(); $event.stopPropagation()">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>

  <!-- Calendar Dropdown -->
  <div class="calendar-dropdown" *ngIf="isOpen" (click)="$event.stopPropagation()">
    <!-- Calendar Header -->
    <div class="calendar-header">
      <div class="month-year" (click)="goToYearView()">
        {{ getMonthYearDisplay() }}
        <div class="dropdown-arrow" [class.rotated]="isYearView">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      <div class="navigation-arrows">
        <button class="nav-arrow" (click)="previousYearRange()" type="button" *ngIf="isYearView">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="nav-arrow" (click)="nextYearRange()" type="button" *ngIf="isYearView">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Year Selection View -->
    <div class="year-view" *ngIf="isYearView">
      <div class="year-header">
        <div class="year-range">
          {{ yearRange[0] }} - {{ yearRange[yearRange.length - 1] }}
          <div class="up-arrow">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 15L12 9L6 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <div class="navigation-arrows">
          <button class="nav-arrow" (click)="previousYearRange()" type="button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button class="nav-arrow" (click)="nextYearRange()" type="button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
      <div class="year-grid">
        <div 
          class="year-item" 
          *ngFor="let year of yearRange"
          [class.selected]="year === currentMonth.getFullYear()"
          (click)="selectYear(year)"
        >
          {{ year }}
        </div>
      </div>
    </div>

    <!-- Month Selection View -->
    <div class="month-view" *ngIf="!isYearView">
      <div class="month-grid">
        <div 
          class="month-item" 
          *ngFor="let month of months; let i = index"
          [class.selected]="isSelected(i)"
          [class.disabled]="isDisabled(i, currentMonth.getFullYear())"
          (click)="!isDisabled(i, currentMonth.getFullYear()) && selectMonth(i)"
        >
          {{ month.substring(0, 3) }}
        </div>
      </div>
    </div>
  </div>
</div> 